<template>
	<page>
		<module title="满赠满减活动详情">
			<c-detail title="" v-if="activityInfo">
				<c-detail-item label="活动名称">{{activityInfo.name}}</c-detail-item>
				<c-detail-item label="活动时间">{{activityInfo.begin_date}} - {{activityInfo.end_date}}</c-detail-item>
				<c-detail-item label="是否叠加">{{activityInfo.kinds == 1 ? '叠加' : '不叠加'}}</c-detail-item>
				<c-detail-item label="活动类型">{{activityInfo.type == 1 ? '满减' : '满赠'}}</c-detail-item>
				<c-detail-item label="门槛及奖励规则" full>
					订单
					<span v-if="activityInfo.kinds == 1">每</span>
					<span v-if="activityInfo.type == 1">满{{activityInfo.reward_order_product_money}}减{{activityInfo.reduce_money}}</span>
					<span v-if="activityInfo.type == 2">满{{activityInfo.reward_order_product_money}}送赠品，赠品如下：</span>
					<c-table v-model="productList" height="auto" style="margin-top:10px;" border v-if="activityInfo.type == 2" >
						<c-table-column
							label="商品信息"
							name="product_name"
							width="200"
						>
							<template v-slot="{data}">
								<div class="flex-center">
									<c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
									<p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
								</div>
							</template>
						</c-table-column>
						
						<c-table-column
							label="商品货号"
							name="product_itemnumber"
						></c-table-column>
						
						<c-table-column
							label="商品规格"
							name="product_sku_spec"
						></c-table-column>
						
						<c-table-column
							label="价格"
							name="product_price"
							width="80"
						>
							<template v-slot="{data}">￥{{data.product_price}}</template>
						</c-table-column>
						
						<c-table-column
							label="库存"
							name="stock_count"
							width="80"
						></c-table-column>
						
						<c-table-column
							label="赠送数量"
							width="100"
							name="count"
						>
						</c-table-column>
						
					</c-table>
				</c-detail-item>
			</c-detail>
		</module>
  </page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'global_reward_detail',
		
		props: {
			id: String
		},
		
		data() {
			return {
				activityInfo: {},
				productList: []
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getActivityDetail();
			}
		},
		
		mounted() {
			this.getActivityDetail();
		},
		
		methods: {
			getActivityDetail() {
				this.request({
					url: '/globalReward/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.activityInfo = data;
						this.productList = data.product_list;
					}
				});
			}
		}
	}
</script>